import React from 'react';
import './tabs.css';

const Tabs = ({ setStatus, status }) => {
  const statusHandler = (e) => {
    setStatus(e.target.innerText);
  };

  return (
    <div className='tabs'>
      <div onClick={statusHandler} className='tabs-nav todo-filter'>
        <div
          className={`tabs-nav__item tabs-nav__item--all ${
            status === 'All' ? 'is-active' : ''
          }`}
        >
          All
        </div>
        <div
          className={`tabs-nav__item ${status === 'Active' ? 'is-active' : ''}`}
        >
          Active
        </div>
        <div
          className={`tabs-nav__item ${status === 'Done' ? 'is-active' : ''}`}
        >
          Done
        </div>
      </div>
    </div>
  );
};

export default Tabs;
